import Vue from 'vue';
import store from '@/store';

class OrderNotificationService {
    constructor() {
        this.timerId = null;
        this.lastOrderId = null;
        this.audio = null;
        this.isInitialized = false;
    }

    init() {
        if (this.isInitialized) {
            return;
        }

        this.audio = new Audio();
        this.audio.preload = 'auto';
        
        try {
            this.audio.src = require('@/assets/mp3/new_order.mp3');
        } catch (error) {
            console.error('Ошибка загрузки звукового файла:', error);
            this.audio.src = '/assets/mp3/new_order.mp3';
        }

        this.isInitialized = true;
        console.log('OrderNotificationService инициализирован');
    }

    start() {
        if (this.timerId) {
            return;
        }

        this.init();
        this.checkForNewOrders();
        this.timerId = setInterval(() => {
            this.checkForNewOrders();
        }, 3000);

        console.log('OrderNotificationService запущен');
    }

    stop() {
        if (this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
            console.log('OrderNotificationService остановлен');
        }
    }

    async checkForNewOrders() {
        try {
            if (!store.state.settings.soundsOn) {
                return;
            }

            const params = {
                main: 1,
                in_work: true,
                limit: 1,
            };

            const response = await Vue.axios.get('/orders', { params });
            const orders = response.data;

            if (orders && orders.length > 0) {
                const firstOrder = orders[0];
                
                if (this.lastOrderId === null) {
                    this.lastOrderId = firstOrder.id;
                    return;
                }

                if (this.lastOrderId !== firstOrder.id) {
                    this.playNotificationSound();
                    this.showNotification(firstOrder);
                    this.lastOrderId = firstOrder.id;
                }
            }
        } catch (error) {
            console.error('Ошибка при проверке новых заказов:', error);
        }
    }

    playNotificationSound() {
        if (this.audio && store.state.settings.soundsOn) {
            try {
                this.audio.currentTime = 0;
                this.audio.play().catch(error => {
                    console.error('Ошибка воспроизведения звука:', error);
                });
            } catch (error) {
                console.error('Ошибка при попытке воспроизвести звук:', error);
            }
        }
    }

    showNotification(order) {
        if (Vue.prototype.$root && Vue.prototype.$root.$emit) {
            Vue.prototype.$root.$emit('showNewOrderNotification', order);
        }

        if ('Notification' in window && Notification.permission === 'granted') {
            new Notification('Новый заказ', {
                body: `Поступил новый заказ №${order.id}`,
                icon: '/favicon.ico',
                tag: 'new-order'
            });
        }
    }

    requestNotificationPermission() {
        if ('Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission();
        }
    }
}

const orderNotificationService = new OrderNotificationService();

export default orderNotificationService; 